import { render, staticRenderFns } from "./ImageSliderWidget.vue?vue&type=template&id=58d485da&scoped=true&"
import script from "./ImageSliderWidget.vue?vue&type=script&lang=js&"
export * from "./ImageSliderWidget.vue?vue&type=script&lang=js&"
import style0 from "./ImageSliderWidget.vue?vue&type=style&index=0&id=58d485da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d485da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCarousel,VCarouselItem,VImg})
